<h1 mat-dialog-title color="accent" class="titleDialog">
    {{name}}
    <button mat-icon-button (click)="editName()">
        <mat-icon class=colorizedIcon>edit</mat-icon>
    </button>
</h1>
<div mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close (click)="onNoClick()" #btnRef="matButton">X</button>
</div>
<div mat-dialog-content class="content">
    <h2>Ultima Rilevazione</h2>
    <p>Latitudine: <b>{{dataTracker.latitude}}</b></p>
    <p>Longitudine: <b>{{dataTracker.longitude}}</b></p>
    <p>Stato Batteria: <b>{{dataTracker.batteryState}}</b></p>
    <p>Id Dispositivo: <b>{{dataTracker.messengerId}}</b></p>
    <p>Tipo Messaggio: <b>{{dataTracker.messageType}}</b></p>
    <p>Dettaglio Messaggio: <b>{{dataTracker.messageDetail}}</b></p>
    <p>Id Invio: <b>{{dataTracker.id}}</b></p>
    <p>Id Server: <b>{{dataTracker._id}}</b></p>
    <p>Data Ricezione: <b>{{dataToVisualize}}</b><br></p>

    <mat-accordion>
        <mat-expansion-panel (opened)="switchExpansion()" (closed)="switchExpansion()">
            <mat-expansion-panel-header class="right-aligned-header">
                <mat-panel-title class="colorizedTitle">
                    Ricerca Temporale
                </mat-panel-title>
                <mat-panel-description class="alignedDescription">
                    effettua una ricerca dato un intervallo di tempo
                </mat-panel-description>
            </mat-expansion-panel-header>
            Da:<br>
            <div class="">
                <mat-form-field>
                    <mat-label>Data</mat-label>
                    <input matInput [matDatepicker]="pickerDa" (dateInput)="updateDatePicker($event, true)" (click)="pickerDa.open()">
                    <mat-datepicker-toggle matSuffix [for]="pickerDa"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDa></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Orario</mat-label>
                    <input matInput placeholder="Orario" [ngxTimepicker]="darkPickerDa" readonly [format]="24">
                    <ngx-material-timepicker #darkPickerDa [theme]="darkTheme"
                        (timeChanged)="updateTimePicker($event, true)" (timeSet)="updateTimePicker($event, true)">
                    </ngx-material-timepicker>
                </mat-form-field>
            </div>
            <br>
            A:<br>
            <mat-checkbox (change)="adessoClick($event)">Adesso</mat-checkbox>
            <div class="">
                <mat-form-field>
                    <mat-label>Data</mat-label>
                    <input matInput [matDatepicker]="pickerA" [disabled]="adesso"
                        (dateInput)="updateDatePicker($event, false)" (click)="pickerA.open()">
                    <mat-datepicker-toggle matSuffix [for]="pickerA" [disabled]="adesso"></mat-datepicker-toggle>
                    <mat-datepicker #pickerA></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Orario</mat-label>
                    <input matInput placeholder="Orario" [ngxTimepicker]="darkPickerA" readonly [disabled]="adesso"
                        [format]="24">
                    <ngx-material-timepicker #darkPickerA [theme]="darkTheme"
                        (timeChanged)="updateTimePicker($event, false)" (timeSet)="updateTimePicker($event, false)">
                    </ngx-material-timepicker>
                </mat-form-field>
            </div>
            <br>
            <div mat-dialog-actions align="end">
                <button mat-raised-button (click)="ricerca(true)" color="warn">Avvia Ricerca</button>
            </div>

            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 fullWidth" *ngIf="dataSource.length > 0">

                <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef> No. </th>
                    <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                </ng-container>

                <ng-container matColumnDef="Latitudine">
                    <th mat-header-cell *matHeaderCellDef> Latitudine </th>
                    <td mat-cell *matCellDef="let element"> {{element.latitudine}} </td>
                </ng-container>

                <ng-container matColumnDef="Longitudine">
                    <th mat-header-cell *matHeaderCellDef> Longitudine </th>
                    <td mat-cell *matCellDef="let element"> {{element.longitudine}} </td>
                </ng-container>

                <ng-container matColumnDef="Data">
                    <th mat-header-cell *matHeaderCellDef> Data </th>
                    <td mat-cell *matCellDef="let element"> {{element.data}} </td>
                </ng-container>

                <ng-container matColumnDef="Altitudine">
                    <th mat-header-cell *matHeaderCellDef> Altitudine </th>
                    <td mat-cell *matCellDef="let element"> {{element.altitudine}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </mat-expansion-panel>
        <mat-expansion-panel (opened)="switchExpansion()" (closed)="switchExpansion()">
            <mat-expansion-panel-header class="right-aligned-header">
                <mat-panel-title class="colorizedTitle">
                    Ricerca per Tipo
                </mat-panel-title>
                <mat-panel-description class="alignedDescription">
                    effettua una ricerca per tipo
                </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-form-field appearance="fill">
                <mat-label>Seleziona Tipo</mat-label>
                <mat-select [(ngModel)]="tipologia">
                    <mat-option *ngFor="let sType of searchType" [value]="sType">{{sType}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div mat-dialog-actions align="end">
                <button mat-raised-button (click)="ricerca(false)" color="warn">Avvia Ricerca</button>
            </div>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 fullWidth" *ngIf="dataSource.length > 0">

                <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef> N. </th>
                    <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                </ng-container>

                <ng-container matColumnDef="Latitudine">
                    <th mat-header-cell *matHeaderCellDef> Latitudine </th>
                    <td mat-cell *matCellDef="let element"> {{element.latitudine}} </td>
                </ng-container>

                <ng-container matColumnDef="Longitudine">
                    <th mat-header-cell *matHeaderCellDef> Longitudine </th>
                    <td mat-cell *matCellDef="let element"> {{element.longitudine}} </td>
                </ng-container>

                <ng-container matColumnDef="Data">
                    <th mat-header-cell *matHeaderCellDef> Data </th>
                    <td mat-cell *matCellDef="let element"> {{element.data}} </td>
                </ng-container>

                <ng-container matColumnDef="Altitudine">
                    <th mat-header-cell *matHeaderCellDef> Altitudine </th>
                    <td mat-cell *matCellDef="let element"> {{element.altitudine}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-expansion-panel>
        <div mat-dialog-actions align="end">
            <button mat-raised-button (click)="azzeraRicerca()" *ngIf="azzeraRicercaVisible" color="accent">Azzera
                Ricerca</button>
        </div>
    </mat-accordion>
</div>